import { Box, HStack, Skeleton, SkeletonCircle, SkeletonText, VStack } from "@reverb-ui/react";

export type TListCardSkeletonProps = {
  numberOfCards: number;
  spacingBetween: number;
  hasUpperText?: boolean;
  hasSubText?: boolean;
  hasVariationPeriod?: boolean;
  hasRecomendation?: boolean;
};

export type TCardSkeletonProps = {
  hasUpperText?: boolean;
  hasSubText?: boolean;
  hasVariationPeriod?: boolean;
  hasRecomendation?: boolean;
};

const isLoaded : boolean = false;

export const CardSkeleton = ({
  hasUpperText = false,
  hasSubText = false,
  hasVariationPeriod = false,
  hasRecomendation = false
} : TCardSkeletonProps) => {

  return (
    <Box p={6} bg="white" w="full">
      <HStack spacing={3} pb={3}>
        <SkeletonCircle isLoaded={isLoaded} variant="rect" width={4} height={4} />
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"50%"} />
      </HStack>

      {hasUpperText && (
        <SkeletonText isLoaded={isLoaded} variant="rect" paddingTop={"1%"} noOfLines={1} />
      )}
      <SkeletonText isLoaded={isLoaded} variant="rect" paddingTop={"0.8%"} noOfLines={1} skeletonHeight={"1.5rem"} />
      {hasSubText && (
        <SkeletonText isLoaded={isLoaded} variant="rect" paddingTop={"1%"} noOfLines={1} />
      )}
                
      {hasVariationPeriod &&(
        <HStack pt={6} alignItems="top">
          <SkeletonCircle isLoaded={isLoaded} variant="rect" width={3} height={3} />
          <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} skeletonHeight={"1rem"} width={"12%"} />
          <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={2} width={"50%"} />
        </HStack>
      )}

      {hasRecomendation &&(
        <HStack pt={5} alignItems="top">
          <Skeleton isLoaded={isLoaded} variant="rect" width={"100%"} height={"5rem"} />
        </HStack>
      )}
    </Box>
  );
};

export const ListCardSkeleton = ({
    numberOfCards = 1,
    spacingBetween = 1,
    hasUpperText = false,
    hasSubText = false,
    hasVariationPeriod = false,
    hasRecomendation = false
} : TListCardSkeletonProps) => {

  return (
    <VStack w="full" spacing={spacingBetween}>
      {Array(numberOfCards).fill(0).map((item, index) => (
        <CardSkeleton 
          key={index}
          hasUpperText={hasUpperText} 
          hasSubText = {hasSubText}
          hasVariationPeriod = {hasVariationPeriod}
          hasRecomendation = {hasRecomendation}
        />
      ))}
    </VStack>
  );
};

